import { useEffect } from 'react';
import usePrevious from './usePrevious';

export default (formStatus, onSuccess = () => {}, onError = () => {}) => {
  const prevValue = usePrevious(formStatus);

  useEffect(() => {
    if (!prevValue || !prevValue.pending || formStatus.pending) {
      return;
    }
    if (formStatus.hasError || (formStatus.errors && formStatus.errors.length)) {
      onError();
    } else {
      onSuccess();
    }
  }, [formStatus.pending]);
};
